var ossUrl = 'https://website-asc.oss-cn-shanghai.aliyuncs.com/';
export default {
    formatImgUrl(url){
        return url ? ossUrl + url : ''
    }
}
